import { propertyFetch } from './property-api'

export type PropertyHeroSlideAccent = 'green' | 'blue' | 'orange' | 'white'
export type PropertyHeroSlideIconKey = 'search' | 'home' | 'building' | 'megaphone' | 'message'
export type PropertyHeroSlideRecord = {
  id: string
  renderMode: 'image' | 'canvas'
  imageUrl: string
  badge: string
  title: string
  description: string
  href: string
  actionLabel: string
  accent: PropertyHeroSlideAccent
  iconKey: PropertyHeroSlideIconKey
  order: number
  isActive: boolean
  startsAt: string | null
  endsAt: string | null
}

export async function loadPropertyHomeHeroSlides() {
  const { items } = await propertyFetch<{ items: PropertyHeroSlideRecord[] }>('/v1/property/hero-slides', { public: true })
  return items.filter(item => item.isActive && item.actionLabel && (item.renderMode === 'canvas' ? item.title && item.description : item.imageUrl))
    .map(item => ({ ...item, accent: (item.accent as string) === 'black' ? 'white' as const : item.accent, order: Number(item.order) || 1 }))
    .sort((a, b) => a.order - b.order || a.title.localeCompare(b.title))
}
